export default "__VITE_ASSET__Cv9Lo6Hh__"